import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './flatbutton.module.scss';

class FlatButton extends Component {

    render() {
        const { to, className, imageUrl } = this.props;
        const style = {
            fontFamily: 'Lato',
            fontSize: '14px',
            color: '#534d9a',
            display: 'flex',
            alignItems: 'baseline',
            padding: '4px 20px 6px',
            borderRadius: '15px',
            border: 'solid 1px rgba(83, 77, 154, 0.5)',
            marginRight: '10px',
            cursor: 'pointer'
        };

        return <Link to={to} onClick={this.props.onReplyClick} className={className} style={style}>
            <img src={imageUrl} className={styles['icon-style']} style={{ width: this.props.iconWidth }} />
            {this.props.children}
        </Link>
    }
}

FlatButton.propTypes = {};

FlatButton.defaultProps = {};

export default FlatButton;



// WEBPACK FOOTER //
// /src/components/UiComponents/FlatButton/FlatButton.js